// @flow
import type { AppState } from 'modules/rootReducer';
import type { JobPost } from 'types/careers';
import type { RecommendedScreenType } from 'types/common';
import { HomeSelector } from 'modules/home/selector';
import { TestimonialSelector } from 'modules/testimonials/selector';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { CareersMapper } from 'mappers/careers';

const getJobPosts = (state: AppState): Array<JobPost> | null => {
  return state.career.jobPosts;
};

const getJobPostsLoading = (state: AppState): boolean => {
  return state.career.loading.jobPosts;
};

const getJobPostsError = (state: AppState): string | null => {
  return state.career.error.jobPosts;
};

const getSpecificJobPosts = (state: AppState): Object<JobPost> | null => {
  return state.career.specificJobPost;
};

const getSpecificJobPostsLoading = (state: AppState): boolean => {
  return state.career.loading.specificJobPost;
};

const getSpecificJobPostsError = (state: AppState): string | null => {
  return state.career.error.specificJobPost;
};

const isCareerLandingPageLoading = (state: AppState): boolean => {
  return (
    HomeSelector.getContactsLoading(state) ||
    HomeSelector.getVerticalsLoading(state) ||
    HomeSelector.getSiteSettingsLoading(state) ||
    TestimonialSelector.getTestimonialLoading(state) ||
    CmsPagesSelector.isCmsPageLoading(state) ||
    getJobPostsLoading(state)
  );
};

const getRelatedRoles = (
  state: AppState
): Array<RecommendedScreenType> | null => {
  return CareersMapper.mapRelatedRoles(state);
};

export const CareerSelector = {
  getJobPosts,
  getJobPostsLoading,
  getJobPostsError,
  isCareerLandingPageLoading,
  getSpecificJobPosts,
  getSpecificJobPostsLoading,
  getSpecificJobPostsError,
  getRelatedRoles,
};
